(function () {
    'use strict';

    angular.module("imApp").factory("consignmentSplitLineService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1454,
                    parameters: parms || {}
                });
            },
            listSplitLines: function (parms) {
                return $ihttp.post({
                    method: 1455,
                    parameters: parms || {}
                });
            },
            saveObj: function (mergeObj) {
                return $ihttp.post({
                    method: 1456,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
